import axios from "../../config/axiosConfig";
import { BANK_PAYMENT_RETURN_REQUEST, BANK_PAYMENT_RETURN_REQUEST_FAILURE, GET_BANK_PAYMENT_RETURNS, CREATE_BANK_PAYMENT_RETURN,
  UPDATE_BANK_PAYMENT_RETURN, DELETE_BANK_PAYMENT_RETURN, BANK_PAYMENT_RETURN_REQUEST_SUCCESS } from "../types";
import { Entry_Type } from "@/utils";

export const getBankPaymentReturns = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_PAYMENT_RETURN_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      return axios.get("/bank-payment-return/getAll", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_BANK_PAYMENT_RETURNS, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_PAYMENT_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_PAYMENT_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getBankPaymentReturnById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_PAYMENT_RETURN_REQUEST });
    
      return axios.get(`/bank-payment-return/get/${id}`).then((response) => {
        dispatch({ type: BANK_PAYMENT_RETURN_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_PAYMENT_RETURN_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_PAYMENT_RETURN_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createBankPaymentReturn = (data) => {
  console.log("Data",data);
  
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: BANK_PAYMENT_RETURN_REQUEST });
      return axios.post("/bank-payment-return/add", data,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_BANK_PAYMENT_RETURN, payload: response.data });
        } else {
          dispatch({
            type: BANK_PAYMENT_RETURN_REQUEST_FAILURE,
            error: "Bank Payment create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_PAYMENT_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_PAYMENT_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateBankPaymentReturn = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_PAYMENT_RETURN_REQUEST });
      const { auth } = getState();
      return axios.put("/bank-payment-return/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Payment?.Company_Id || auth.company?.id,
            finyearId: data.Payment?.Finyear_Id || auth.finyear?.id,
            customerId: data.Payment?.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_BANK_PAYMENT_RETURN,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: BANK_PAYMENT_RETURN_REQUEST_FAILURE,
            error: "Bank Payment update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_PAYMENT_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_PAYMENT_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteBankPaymentReturn = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: BANK_PAYMENT_RETURN_REQUEST });
      const { auth } = getState();
      return axios.delete(`/bank-payment-return/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_BANK_PAYMENT_RETURN, id: id });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: BANK_PAYMENT_RETURN_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: BANK_PAYMENT_RETURN_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getPaymentDetailsByBankPaymentReturnIds = (ids) => {
  return async (dispatch, getState) => {
    try {
      const params = {
        transIds: ids,
        billType: Entry_Type.BANK_PAYMENT_RETURN
      };
      return axios.get(`/bill-adjustment/get-payment-detail-by-multy-ids`, { params })
        .then((response) => {
          return response?.data;
        }).catch((error) => {
          console.error(error);
          throw error;
        });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};